var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibrary04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.995117,
    y: 0.0859375,
    width: 350,
    height: 233,
    fill: "#D38D8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.417 167.463L313.817 133.359L313.816 136.91L239.416 171.013L239.417 167.463Z",
    fill: "#3C6388"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.413 167.432L136.564 122.199L136.563 125.75L239.412 170.982L239.413 167.432Z",
    fill: "#2B4A67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.202 179.036L118.354 133.803L136.558 125.746L239.407 170.979L221.202 179.036Z",
    fill: "#1C3043"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.488 122.201L210.889 88.0977L262.389 110.72L187.989 144.823L136.488 122.201Z",
    fill: "#4D85B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.488 122.201L210.889 88.0977L262.389 110.72L187.989 144.823L136.488 122.201Z",
    fill: "url(#paint0_linear_569_27182)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.916 144.822L262.316 110.719L313.817 133.341L239.417 167.445L187.916 144.822Z",
    fill: "#4D85B9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.916 144.822L262.316 110.719L313.817 133.341L239.417 167.445L187.916 144.822Z",
    fill: "url(#paint1_linear_569_27182)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.194 131.303L142.821 109.734L142.818 121.668L191.191 143.236L191.194 131.303Z",
    fill: "#A5ABB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.194 131.303L142.821 109.734L142.818 121.668L191.191 143.236L191.194 131.303Z",
    fill: "url(#paint2_linear_569_27182)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M239.568 152.882L191.195 131.191V143.319L239.568 164.887V152.882Z",
    fill: "#A5ABB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M239.568 152.882L191.195 131.191V143.319L239.568 164.887V152.882Z",
    fill: "url(#paint3_linear_569_27182)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M239.572 152.968L307.627 121.082L307.623 133.016L239.568 164.902L239.572 152.968Z",
    fill: "#C9DDF0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M239.611 152.855L142.821 109.753L210.896 77.9727L307.646 121.08L239.611 152.855Z",
    fill: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_569_27182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 83,
    width: 59,
    height: 34
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.122 116.457L163.193 106.74L204.007 83.1719L221.936 92.8884L181.122 116.457Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_569_27182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.398 108.252C176.333 108.289 176.275 108.325 176.202 108.362L174.203 109.386L169.174 106.428L171.166 105.404C172.852 104.546 174.669 104.713 176.144 105.593C177.597 106.436 177.852 107.417 176.398 108.26M163.818 106.392L178.753 115.178L181.573 113.725L176.703 110.861L179.145 109.604C179.269 109.539 179.392 109.473 179.509 109.408C182.263 107.816 181.921 105.774 179.058 104.096C176.115 102.366 172.249 102.046 169.16 103.645L163.826 106.392",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.324 106.638C187.532 107.096 187.619 107.881 188.549 108.404C189.486 108.978 190.976 109.065 191.863 108.608C191.885 108.593 191.907 108.586 191.928 108.571C192.691 108.135 192.619 107.336 191.689 106.783C190.736 106.224 189.239 106.144 188.411 106.58C188.375 106.594 188.346 106.616 188.316 106.631",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.185 99.597C193.12 99.6333 193.054 99.6696 192.982 99.706L190.99 100.731L185.954 97.7656L187.945 96.7409C189.631 95.8833 191.448 96.0505 192.924 96.9298C194.377 97.7728 194.639 98.7539 193.185 99.5897M180.598 97.722L195.533 106.516L198.352 105.062L193.483 102.199L195.925 100.941C196.049 100.876 196.165 100.811 196.274 100.752C199.035 99.1609 198.694 97.1188 195.831 95.4327C192.887 93.7031 189.021 93.3833 185.925 94.9749L180.591 97.722",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.531 91.5801L207.473 100.374L210.249 98.942L195.315 90.1484L192.531 91.5801Z",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.357 90.4251L208.019 92.6635C206.834 91.9077 206.645 90.8757 207.786 90.2144C207.83 90.1853 207.881 90.1635 207.931 90.1344C209.16 89.4877 210.991 89.6257 212.365 90.4179M205.293 88.9717C202.619 90.5124 203.106 92.8016 206.456 94.7638C209.995 96.8568 214.13 97.1765 217.27 95.5705C217.379 95.5123 217.488 95.4542 217.59 95.396C219.799 94.117 220.053 92.5472 218.447 91.181L215.802 92.5472C216.18 93.0559 215.991 93.6446 215.155 94.1315C215.119 94.1533 215.083 94.1751 215.039 94.1969C213.593 94.9309 211.638 94.7856 209.944 93.7899L216.914 90.1999L216.042 89.6911C212.226 87.4455 208.251 87.4382 205.577 88.8191C205.475 88.8699 205.381 88.9208 205.286 88.9789",
    fill: "#D1DFEB"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M239.693 153.044L191.195 131.221L259.249 99.4375L307.747 121.26L239.693 153.044Z",
    fill: "#EAF5FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M239.693 153.044L191.195 131.221L259.249 99.4375L307.747 121.26L239.693 153.044Z",
    fill: "url(#paint4_linear_569_27182)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231.09 121.878L191.195 131.218L259.249 99.4342L299.144 90.0939L231.09 121.878Z",
    fill: "#E4EEF7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M231.09 121.878L191.195 131.218L259.249 99.4342L299.144 90.0939L231.09 121.878Z",
    fill: "url(#paint5_linear_569_27182)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_27182",
    x1: 184.089,
    y1: 102.444,
    x2: 199.439,
    y2: 144.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D85B9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2264A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_27182",
    x1: 208.301,
    y1: 131.362,
    x2: 236.17,
    y2: 153.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2264A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D85B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_569_27182",
    x1: 191.195,
    y1: 138.7,
    x2: 142.818,
    y2: 117.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82878B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5ABB0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_569_27182",
    x1: 191.195,
    y1: 137.916,
    x2: 239.568,
    y2: 160.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858C92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5ABB0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_569_27182",
    x1: 233.302,
    y1: 115.422,
    x2: 243.19,
    y2: 154.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8B1B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_569_27182",
    x1: 230.602,
    y1: 106.4,
    x2: 243.448,
    y2: 131.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C7CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EEF6",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary04);
export default __webpack_public_path__ + "static/media/library_04.ae688840d4d823e8c030e8542712b4e9.svg";
export { ForwardRef as ReactComponent };